module.exports = __webpack_public_path__ + "static/img/13.e2a161e4.png";